import React, { useState } from "react";
import "./Portfolio.css";
import { useTranslation } from "react-i18next";
import vb1 from "../../assets/vb1.png";
import sk1 from "../../assets/sk1.png";

const projects = [
  {
    id: "vb",
    image: vb1,
    link: "https://github.com/egohommeli12345/VillageBase",
  },
  { id: "sk",
    image: sk1,
    link: "https://savonkoti.fi/"
  },
  { id: "coming", image: "", link: "" },
];

const Portfolio = ({ id }) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [activeId, setActiveId] = useState(null);

  const nextSlide = () => setCurrentIndex((i) => (i + 1) % projects.length);
  const prevSlide = () =>
    setCurrentIndex((i) => (i === 0 ? projects.length - 1 : i - 1));

  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchMove = (e) => setTouchEndX(e.touches[0].clientX);
  const handleTouchEnd = () => {
    if (touchStartX - touchEndX > 50) nextSlide();
    if (touchStartX - touchEndX < -50) prevSlide();
  };

  const slideStyle = { transform: `translateX(-${currentIndex * 100}%)` };

  return (
    <div id={id} className="portfolio">
      <div className="p-title">
        <h1>{t("portfolio.title")}</h1>
      </div>

      <div
        className="carousel"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button
          className="carousel-button prev"
          onClick={prevSlide}
          aria-label="Previous"
        >
          ‹
        </button>

        <div className="carousel-container" style={slideStyle}>
          {projects.map((p, idx) => (
            <div
              className="carousel-item"
              key={p.id}
              onClick={() => setActiveId(p.id)}
            >
              {p.image ? (
                <img src={p.image} alt={t(`portfolio.items.${p.id}.name`)} />
              ) : (
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    display: "grid",
                    placeItems: "center",
                    borderRadius: 10,
                    border: "2px dashed #555",
                    color: "#aaa",
                  }}
                >
                  {t(`portfolio.items.${p.id}.name`)}
                </div>
              )}
              <h3>{t(`portfolio.items.${p.id}.name`)}</h3>
            </div>
          ))}
        </div>

        <button
          className="carousel-button next"
          onClick={nextSlide}
          aria-label="Next"
        >
          ›
        </button>
      </div>

      {activeId && (
        <div className="modal" onClick={() => setActiveId(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => setActiveId(null)}>
              &times;
            </span>

            <div className="modal-body">
              {projects.find((p) => p.id === activeId)?.image && (
                <img
                  src={projects.find((p) => p.id === activeId).image}
                  alt={t(`portfolio.items.${activeId}.name`)}
                  className="modal-image"
                />
              )}
              <div className="modal-text">
                <h2 style={{ marginTop: 0 }}>
                  {t(`portfolio.items.${activeId}.modalTitle`)}
                </h2>
                <p>{t(`portfolio.items.${activeId}.modalBody1`)}</p>
                <br />
                <p>{t(`portfolio.items.${activeId}.modalBody2`)}</p>

                {projects.find((p) => p.id === activeId)?.link && (
                  <>
                    <br />
                    <a
                      href={projects.find((p) => p.id === activeId).link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(`portfolio.items.${activeId}.linkLabel`)}
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Portfolio;
